import React from "react";
import { URL_INFURA, SHIPPING } from "../helpers";
import ShowTotalCart from "./ShowTotalCart";
import ShowTotal from "./ShowTotal";
import ShowDiscount from "./ShowDiscount";
import FormCheckout from "./FormCheckout";

const styles = {
  title: {
    textAlign: "center",
    fontWeight: "200",
  },
  resumen: {
    backgroundColor: "#f8f8f8",
    width: "100%",
    padding: "20px 30px",
    borderLeft: "2px solid #DDD",
  },
  form: {
    backgroundColor: "#fff",
    width: "100%",
    color: "#222",
    padding: "20px 5px",
  },
  img: {
    borderRadius: "5px",
  },
  product: {
    width: "80%",
    color: "#222",
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 10px 5px",
    borderBottom: "1px solid #DDD",
    marginBottom: "2em",
  },
  ProductDetail: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    color: "#222",
  },
  bubble: {
    backgroundColor: "#DDD",
    color: "#222",
    width: "15px",
    borderRadius: "1.75em",
    fontSize: ".9rem",
    textAlign: "center",
    boxSizing: "border-box",
    minWidth: "1.75em",
    height: "1.75em",
    padding: "0 0.5833333333em",
    left: "2.2em",
    top: "-0.75em",
    lineHeight: "1.75em",
    position: "absolute",
  },
};

export default function Checkout({
  carrito,
  formShipping,
  handleSubmitFormShipping,
}) {
  return (
    <div>
      <h1 style={styles.title}>Check Out</h1>

      <div className="checkout-container">
        <div style={styles.form}>
          CONTACT INFORMATION
          <br />
          <br />
          <FormCheckout
            formShipping={formShipping}
            handleSubmitFormShipping={handleSubmitFormShipping}
          />
        </div>

        <div style={styles.resumen}>
          {carrito.map((x) => {
            return (
              <div style={styles.product}>
                <div style={styles.ProductDetail}>
                  <img
                    with="140"
                    height="60"
                    src={`${URL_INFURA}${x.url_image_1}`}
                    alt={x.title}
                    style={styles.img}
                  />
                  <span style={styles.bubble}>{x.cantidad}</span>
                  <span style={{ marginLeft: "10px" }}>{x.title}</span>
                </div>
                <p>${x.price * x.cantidad}</p>
              </div>
            );
          })}


          <div
            style={{
              fontWeight: "300",
              marginTop: "10px",
              padding: "10px",
              width: "80%",
              display: "flex",
              justifyContent: "space-between",
              color: "#222",
            }}
          >
            SubTotal <ShowTotalCart carrito={carrito} />
          </div>


          <div
            style={{
              fontWeight: "300",
              marginTop: "10px",
              padding: "10px",
              width: "80%",
              display: "flex",
              justifyContent: "space-between",
              color: "#222",
            }}
          >
            Descuentos <ShowDiscount carrito={carrito} />
          </div>

          <div
            style={{
              fontWeight: "300",
              padding: "10px",
              width: "80%",
              display: "flex",
              justifyContent: "space-between",
              color: "#222",
            }}
          >
            Shipping
            <span>+ ${SHIPPING}</span>
          </div>
          <div
            style={{
              borderTop: "1px solid #DDD",
              marginTop: "10px",
              padding: "10px",
              width: "80%",
              display: "flex",
              justifyContent: "space-between",
              color: "#222",
              fontSize: "1.2em",
            }}
          >
            Total
            <ShowTotal carrito={carrito} />
          </div>
        </div>
      </div>
    </div>
  );
}
